module.exports = __webpack_public_path__ + "static/media/warning-white.c6af7e58.svg";